import b_ from 'b_';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './ConsoleFragments.css';

const block = b_.lock('ConsoleList');

export default function ConsoleList({ className, title, focusedItemIndex, children, ...otherProps }) {
    return <div
        className={cn(block(), className)}
        {...otherProps}
    >
        <div className={block('Head')}>{title}</div>
        <div className={block('ListWrapper')}>
            <div className={block('List')}>
                {React.Children.map(children, (thisArg, index) => (thisArg === null ? null : <div
                    className={block('Item', { focused: index === focusedItemIndex })}
                >{thisArg}</div>))}
            </div>
        </div>
    </div>;
}

ConsoleList.propTypes = {
    title: PropTypes.node,
    focusedItemIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
